import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(with-global-style)/about-us/DesktopPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(with-global-style)/about-us/MobilePage.tsx");
